<template>
  <div class="dialog">
    <el-dialog :title="info.title" :visible="value" @close="oncancel">
      <el-form :model="form" :rules="rules" label-position="left">
        <el-form-item :label="info.name" :label-width="formLabelWidth" prop="name">
          <el-input
            placeholder="请输入账号名（仅作为内部管理查看）"
            v-model="form.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="info.key1" :label-width="formLabelWidth" prop="name">
          <el-input
            :placeholder="info.pls"
            v-model="form.name2"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="info.key2" :label-width="formLabelWidth" prop="name">
          <el-input
            :placeholder="info.pls"
            v-model="form.name3"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
        <div class="hx"></div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="oncancel" round>取 消</el-button>
        <el-button  type="primary" @click="oncancel" round>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["value", "type"],
  data() {
    return {
      dialogFormVisible: true,
      form: {
        name: "",
        name2: "",
        name3: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      //验证
       rules: {
            name: [
            { required: true, message: '不可为空', trigger: 'blur'  },
          ],
       },
      formLabelWidth: "120px",
    };
  },
  computed: {
    info() {
      if (this.type == 1) {
        return {
          name: "账号名称",
          key1: "AccessKey",
          key2: "AccessKey",
          pls: "请输入密钥（通过阿里云控制台查看）",
           title:'创建账号'
        };
      }else if(this.type == 1.5){
       return {
 name: "账号名称",
          key1: "AccessKey",
          key2: "AccessKey",
          pls: "请输入密钥（通过阿里云控制台查看）",
          title:'编辑'
        }
      } else {
        return {
          name: "账号名称：",
          key1: "app_key：",
          key2: "master_secret：",
          pls: "请输入",
           title:'创建账号'
        };
      }
    },
  },
  methods: {
    oncancel() {
      this.$emit("input", false);
    },
  },
};
</script>

<style lang='less'>
.dialog {
    position: relative;
  .el-dialog__body {
      margin-left: 50px;
    margin-top: 48px;
    margin-bottom: 93px;
    .el-input__inner {
      width: 424px;
      height: 32px;
      background: #F6F6F6;
      border: 0;
    }
  }
  .hx{

      position: absolute;
      left: 0;
      bottom: 70px;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.09000000357627869);
  }
  .el-dialog__body {
     word-break: normal; 
}

}
</style>